export const getSubtopicsProgress = (subtopics, quizProgress) => {
    const subtopicsProgress = [];
    for (let subtopic of subtopics) {
        const value = quizProgress.find(value => {
            return value.subtopicId === subtopic.id && value.finished
        });
        if (value) subtopicsProgress.push(value);
    }
    return subtopicsProgress;
}